@if (data$ | async; as data) {
  <div class="transcription">
    <cv-conversation-header
      (copyTranscript)="onCopyTranscript()"
      (downloadCallAudio)="onDownloadCallAudio(data.transcription.audio.data)"
      (downloadConversationToPDF)="isShowPdfContentSelectionDialog = true"
    />

    <div class="transcriptions__audio-container">
      @if (data.transcription.audio.loading) {
        <p-skeleton width="100%" borderRadius="2.2rem" height="4.5rem" />
      } @else if (
        data.transcription.audio.error &&
        data.transcription.audio.errorResponse?.status === EHttpErrorStatus.serverIssue
      ) {
        <cv-alert> {{ audioErrormessage }}</cv-alert>
      } @else {
        <cv-audio-player
          cvIntersection
          class="transcription__player"
          showedClass="transcription__player--showed"
          intersectedClass="transcription__player--over-scrolled"
          #audioPlayer
          [isMobile]="data.isMobileScreenSize"
          (timeUpdate)="currentAudioTime = $event"
          [audioSource]="data.transcription.audio.data"
        ></cv-audio-player>
      }
    </div>

    @if (!data.transcription.aceTranscription.loading && !data.transcription.standardTranscription.loading) {
      @if (data.transcription | hasTranscription) {
        <p-tabView
          #tabView
          [styleClass]="
            'transcript-tabs ' + (tabView?.tabs && tabView.tabs.length > 1 ? '' : 'transcript-tabs--no-tabs')
          "
        >
          @if (data.transcription.standardTranscription.error) {
            @if (data.transcription.standardTranscription.errorResponse?.status === EHttpErrorStatus.serverIssue) {
              <p-tabPanel [header]="tabEnum.standard">
                <cv-alert> {{ transcriptErrormessage }}</cv-alert>
              </p-tabPanel>
            }
          } @else {
            <p-tabPanel [header]="tabEnum.standard">
              @if (data.transcription.standardTranscription.data?.conversationSummary; as summary) {
                <div class="standard-transcript-summary"><b>Summary: </b><span [innerHTML]="summary"></span></div>
              }
              <cv-transcription-date
                [date]="data.transcription.standardTranscription.data!.startDate"
              ></cv-transcription-date>
              <cv-standard-transcript
                [isMobile]="data.isMobileScreenSize"
                [paragraphs]="data.transcription.standardTranscription.data!.paragraphs"
                [userName]="data.userName"
                [agentName]="data.agentName"
                [currentAudioTime]="currentAudioTime"
                (playFromParagraph)="audioPlayer.play($event)"
              ></cv-standard-transcript>
            </p-tabPanel>
          }

          @if (data.transcription.aceTranscription.error) {
            @if (data.transcription.aceTranscription.errorResponse?.status === EHttpErrorStatus.serverIssue) {
              <p-tabPanel [header]="tabEnum.ace">
                <cv-alert> {{ transcriptErrormessage }}</cv-alert>
              </p-tabPanel>
            }
          } @else {
            <p-tabPanel [header]="tabEnum.ace">
              <cv-transcription-date
                [date]="data.transcription.aceTranscription.data!.startDate"
              ></cv-transcription-date>
              <cv-ace-transcript
                [paragraphs]="data.transcription.aceTranscription.data!.paragraphs"
                [userName]="data.userName"
                [agentName]="data.agentName"
              ></cv-ace-transcript>
            </p-tabPanel>
          }
        </p-tabView>
      }
    } @else {
      <div class="transcription__skeleton-container">
        <p-skeleton width="80%" height="5rem" />
        <p-skeleton width="80%" height="8rem" />
        <p-skeleton width="80%" height="4rem" />
        <p-skeleton width="80%" height="6rem" />
        <p-skeleton width="80%" height="3rem" />
        <p-skeleton width="80%" height="8rem" />
        <p-skeleton width="80%" height="4rem" />
        <p-skeleton width="80%" height="6rem" />
      </div>
    }
  </div>
}

@defer (when isShowPdfContentSelectionDialog) {
  <cv-pdf-content-selection-dialog [isVisible]="isShowPdfContentSelectionDialog" (closeDialog)="isShowPdfContentSelectionDialog = false" />
}

